import React, { useEffect } from "react";
import { Questionnaire as QuestionnaireEntity } from "@r6digital/rapidstor-types/types/Questionnaire";
import Page from "./Page";
import QuestionnaireContext from "./QuestionnaireContext";
import Breadcrumbs from "./Breadcrumbs";
import { changePage, selectPage, setLocation } from "../../store/questionnaireSlice";
import { useSelector } from "react-redux";
import store from "../../store";
import Location from "../../features/rapidstor/entities/Location";
import { useLoaderData } from "react-router-dom";

interface Props {
  questionnaire: QuestionnaireEntity;
}

function Questionnaire({ questionnaire }: Props) {
  const location = useLoaderData() as Location;
  const page = useSelector(selectPage);

  useEffect(() => {
    if (!page) {
      store.dispatch(changePage(questionnaire.pages[questionnaire.firstPage]));
    }
    if (location) {
      store.dispatch(setLocation(location));
    }
  }, [location, page, questionnaire]);

  return (
    <QuestionnaireContext.Provider value={{ questionnaire }}>
      <Breadcrumbs location={location} />
      {page && <Page page={page} />}
    </QuestionnaireContext.Provider>
  );
}

export default Questionnaire;
